import { render, staticRenderFns } from "./UserActivationActivate.vue?vue&type=template&id=0b0bc125"
import script from "./UserActivationActivate.vue?vue&type=script&lang=js"
export * from "./UserActivationActivate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports